import { Injectable } from '@angular/core'

import { ArtistId } from 'src/app/models/artist.model'
import { AngularFireFunctions } from '@angular/fire/compat/functions'
import { Chart } from 'src/app/models/chart.model'
import { Observable } from 'rxjs'
import * as moment from 'moment'

@Injectable({ providedIn: 'root' })
export class ChartService {
  constructor(private functions: AngularFireFunctions) {}

  find(artistId: ArtistId, from: Date, to: Date): Observable<Chart> {
    return this.functions.httpsCallable<{ artistId: ArtistId; from: string; to: string }, Chart>(
      'findCharts'
    )({ artistId, from: moment(from).format('YYYY-MM-DD'), to: moment(to).format('YYYY-MM-DD') })
  }
}
